import * as React from 'react';
import { OptionsCloseButton } from './OptionsCloseButton';

const styles = require('./OptionsFull.scss');

export interface SettingsOverlayProps {
    selectedSubCategoryKey: string;
    onSoftDismiss: () => void;
    children?: React.ReactNode;
}

export function SettingsOverlay({
    selectedSubCategoryKey,
    onSoftDismiss,
    children,
}: SettingsOverlayProps) {
    const onBackgroundClicked = ({ target, currentTarget }: React.MouseEvent) => {
        // Make sure the click was on the backdrop, not the flyouts
        if (target === currentTarget) {
            onSoftDismiss?.();
        }
    };

    return (
        <div className={styles.overlay} onClick={onBackgroundClicked}>
            <OptionsCloseButton selectedSubCategoryKey={selectedSubCategoryKey} />
            {children}
        </div>
    );
}
